import React from "react";
import { useLocation } from "react-router-dom";
import { Badge, Card, Table } from "@themesberg/react-bootstrap";


const getStatusBadgeStyle = (status) => {
  switch (String(status || "").toLowerCase()) {
    case "pending":
    case "inactive":
      return { background: "#f59e0b", color: "#ffffff" };
    case "success":
    case "completed":
    case "active":
    case "issued":
      return { background: "#10b981", color: "#ffffff" };
    case "failed":
    case "blocked":
    case "cancelled":
      return { background: "#ef4444", color: "#ffffff" };
    case "refunded":
            return { background: "#6366f1", color: "#ffffff" };
    default:
      return { background: "#6b7280", color: "#ffffff" };
  }
};


const capitalize = (value) =>
    String(value || "")
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());

const TABLES = [
    {
        key: "my_ids",
        title: "My IDs",
    },
    {
        key: "users",
        title: "Users",
    },
    {
        key: "purchases",
        title: "My Courses",
    },
    {
        key: "courses",
        title: "All Courses",
    },
    {
        key: "direct_referrals",
        title: "Direct Referrals",
    },
    {
        key: "invoices",
        title: "Invoices",
    },
    {
        key: "credit_notes",
        title: "Credit Notes",
    },
    {
        key: "transactions",
        title: "Transactions",
    },
    //   {
    //     key: "wallet",
    //     title: "Wallet",
    //   },
];

export default function SearchResults() {
    const { state } = useLocation();

    const data = state?.data || {};
    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === "") return "-";

        return `₹${Number(value).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    };

    const formatDate = (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (isNaN(date.getTime())) return value;

        return new Intl.DateTimeFormat("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        }).format(date);
    };

    const renderTable = (tableKey, title, rows) => {
        if (!rows) return null;

        if (Array.isArray(rows) && rows.length === 0) return null;

        const tableRows = Array.isArray(rows) ? rows : [rows];

        const renderHeaders = () => {
            switch (tableKey) {

                case "my_ids":
                    return (
                        <tr>
                            <th>Sr No</th>
                            <th>Name</th>
                            <th>Customer ID</th>
                            <th>Username</th>
                            {/* <th>User Type</th> */}
                        </tr>
                    );

                case "users":
                    return (
                        <tr>
                            <th>Sr No</th>
                            <th>Name</th>
                            <th>Customer ID</th>
                            <th>Email</th>
                            {/* <th>User Type</th> */}
                            <th>Status</th>
                        </tr>
                    );


                case "purchases":
                    return (
                        <tr>
                            <th>Sr No</th>
                            <th>Course</th>
                            {/* <th>User</th> */}
                            <th>Amount</th>
                            <th>Date</th>
                            <th>Status</th>
                            {/* <th>Opt Out</th> */}
                        </tr>
                    );

                case "courses":
                    return (
                        <tr>
                            <th>Sr No</th>
                            <th>Course</th>
                            <th>Price</th>
                        </tr>
                    );

                case "direct_referrals":
                    return (
                        <tr>
                            <th>Sr No</th>
                            <th>Name</th>
                            <th>Customer ID</th>
                            <th>Email/Username</th>
                            {/* <th>User Type</th> */}
                        </tr>
                    );

                case "invoices":
                    return (
                        <tr>
                            <th>Sr No</th>
                            <th>Invoice No</th>
                            <th>Course</th>
                            {/* <th>Customer</th> */}
                            <th>Date</th>
                            <th>Amount</th>
                            <th>Status</th>
                        </tr>
                    );

                case "credit_notes":
                    return (
                        <tr>
                            <th>Sr No</th>
                            <th>Credit Note</th>
                            <th>Course</th>
                            {/* <th>Customer</th> */}
                            <th>Date</th>
                            <th>Amount</th>
                            <th>Status</th>
                        </tr>
                    );

                case "transactions":
                    return (
                        <tr>
                            <th>Sr No</th>
                            {/* <th>Type</th>
                            <th>Source</th> */}
                            <th>Amount</th>
                            <th>Payment Method</th>
                            <th>Type</th>
                            <th>Status</th>
                        </tr>
                    );

                //   case "wallet":
                //     return (
                //       <tr>
                //         <th>Wallet Balance</th>
                //       </tr>
                //     );

                default:
                    return null;
            }
        };

        const renderRow = (item, index) => {
            switch (tableKey) {

                case "my_ids":
                    return (
                        <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>
                            <td>{item.custom_user_id}</td>
                            <td>{item.username || "-"}</td>
                            {/* <td>{item.user_type}</td> */}
                        </tr>
                    );


                case "users":
                    return (
                        <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>
                            <td>{item.custom_user_id}</td>
                            <td>{item.email || "-"}</td>
                            {/* <td>{capitalize(item.user_type)}</td> */}
                            <td>
                                <Badge
                                    className="px-3 py-2 rounded-pill"
                                    style={getStatusBadgeStyle(item.status)}
                                >
                                    {capitalize(item.status)}
                                </Badge>
                            </td>
                        </tr>
                    );


                case "purchases":
                    return (
                        <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.course?.title}</td>
                            {/* <td>{item.user?.name}</td> */}
                            <td>{formatCurrency(item.amount_paid)}</td>
                            <td>{item.month_year}</td>
                            <td>
                                <Badge
                                    className="px-3 py-2 rounded-pill"
                                    style={getStatusBadgeStyle(item.status)}
                                >
                                    {capitalize(item.status)}
                                </Badge>
                            </td>
                            {/* <td>{item.opt_out_status ? "Yes" : "No"}</td> */}
                        </tr>
                    );


                case "courses":
                    return (
                        <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.title}</td>
                            <td>{formatCurrency(item.price)}</td>
                        </tr>
                    );


                case "direct_referrals":
                    return (
                        <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>
                            <td>{item.custom_user_id}</td>
                            <td>{item.email || "-"}</td>
                            {/* <td>{capitalize(item.user_type)}</td> */}
                        </tr>
                    );


                case "invoices":
                    return (
                        <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.invoice_number}</td>
                            <td>{item.metadata?.course_title}</td>
                            {/* <td>{item.metadata?.customer_name}</td> */}
                            <td>{formatDate(item.invoice_date)}</td>
                            <td>{formatCurrency(item.total_amount)}</td>
                            <td>
                                <Badge
                                    className="px-3 py-2 rounded-pill"
                                    style={getStatusBadgeStyle(item.status)}
                                >
                                    {capitalize(item.status)}
                                </Badge>
                            </td>
                        </tr>
                    );

                case "credit_notes":
                    return (
                        <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.credit_note_number}</td>
                            <td>{item.metadata?.course_title}</td>
                            {/* <td>{item.metadata?.customer_name}</td> */}
                            <td>{formatDate(item.credit_note_date)}</td>
                            <td>{formatCurrency(item.total_amount)}</td>
                            <td>
                                <Badge
                                    className="px-3 py-2 rounded-pill"
                                    style={getStatusBadgeStyle(item.status)}
                                >
                                    {capitalize(item.status)}
                                </Badge>
                            </td>
                        </tr>
                    );

                case "transactions":
                    return (
                        <tr key={item.id}>
                            <td>{index + 1}</td>
                            {/* <td>{item.type}</td>
                            <td>{item.source}</td> */}
                            <td>{formatCurrency(item.amount)}</td>
                            <td>{capitalize(item.payment_method)}</td>
                            <td>{capitalize(item.type)}</td>
                            <td>
                                <Badge
                                    className="px-3 py-2 rounded-pill"
                                    style={getStatusBadgeStyle(item.status)}
                                >
                                    {capitalize(item.status)}
                                </Badge>
                            </td>
                        </tr>
                    );

                //   case "wallet":
                //     return (
                //       <tr>
                //         <td>{JSON.stringify(item)}</td>
                //       </tr>
                //     );

                default:
                    return null;
            }
        };

        return (
            <Card className="border-0 shadow-sm rounded-4 mb-4">
                <Card.Body>
                    <h5 className="fw-bold mb-3">{title}</h5>

                    <div className="table-responsive">
                        <Table hover className="align-middle mb-0">
                            <thead>{renderHeaders()}</thead>

                            <tbody>
                                {tableRows.map((item, index) => renderRow(item, index))}
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
            </Card>
        );
    };

    const hasData = TABLES.some(({ key }) => {
        const value = data[key];

        if (!value) return false;

        if (Array.isArray(value)) return value.length > 0;

        return true;
    });

    return (
        <div className="search-results-page py-4">
            {hasData ? (
                TABLES.map(({ key, title }) => renderTable(key, title, data[key]))
            ) : (
                <Card className="border-0 shadow-sm rounded-4 py-4">
                    <Card.Body className="text-center py-5 text-muted">
                        No search results found.
                    </Card.Body>
                </Card>
            )}

            <style>{`
        .search-results-page{
            width:100%;
        }

        .search-results-page table th{
            white-space:nowrap;
            font-weight:600;
        }

        .search-results-page table td{
            vertical-align:middle;
        }

        @media(max-width:768px){

            .search-results-page h5{
                font-size:1rem;
            }

            .search-results-page table{
                min-width:650px;
            }

        }
      `}</style>
        </div>
    );
}